import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Box, Stack, Typography } from "@mui/material";
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import BackspaceIcon from '@mui/icons-material/Backspace';
// @ts-ignore
const KeyboardKey = ({ keycode, keyboardListener }) => {
    const clickListener = useCallback(() => {
        let keycodeToEmit = keycode;
        if (keycodeToEmit === "E") {
            keycodeToEmit = 'enter';
        }
        if (keycodeToEmit === "B") {
            keycodeToEmit = 'backspace';
        }
        keyboardListener(keycodeToEmit);
    }, [keycode, keyboardListener]);
    let keyToDisplay = keycode;
    if (keycode === 'E') {
        keyToDisplay = _jsx(KeyboardReturnIcon, {});
    }
    if (keycode === 'B') {
        keyToDisplay = _jsx(BackspaceIcon, {});
    }
    return (_jsx(Box, { sx: {
            background: "lightgray",
            borderRadius: "5px",
            margin: "4px",
            padding: "4px",
            minWidth: "20px",
            minHeight: "30px",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
        }, onClick: clickListener, children: _jsx(Typography, { children: keyToDisplay }) }));
};
// @ts-ignore
export const KeyboardComponent = ({ keyboardListener }) => {
    const row1 = "qwertyuiop";
    const row2 = "asdfghjklñ";
    const row3 = "EzxcvbnmB";
    let compomentKey = 0;
    const row1Components = row1.split('').map((c) => {
        compomentKey++;
        return _jsx(KeyboardKey, { keycode: c, keyboardListener: keyboardListener }, compomentKey);
    });
    const row2Components = row2.split('').map((c) => {
        compomentKey++;
        return _jsx(KeyboardKey, { keycode: c, keyboardListener: keyboardListener }, compomentKey);
    });
    const row3Components = row3.split('').map((c) => {
        compomentKey++;
        return _jsx(KeyboardKey, { keycode: c, keyboardListener: keyboardListener }, compomentKey);
    });
    return (_jsxs(Stack, { sx: {
            alignItems: "center"
        }, children: [_jsx(Stack, { direction: "row", children: row1Components }), _jsx(Stack, { direction: "row", children: row2Components }), _jsx(Stack, { direction: "row", children: row3Components })] }));
};
